<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">固定资产管理</span>
      <span class="dark4-color ">提示：按 Ctrl + F 键并输入可以快速查找。</span>
    </div>
    <div class="margin-right-left margin-top">
<!--      <Button color="primary" @click="add">添加资产</Button>-->
      <Button color="primary" @click="add1">添加资产</Button>
      <Button color="primary" @click="exportExcel">导出Excel</Button>

      <label style="margin-left: 20px">模糊查询：</label>
      <input type="text" v-model="assetsCodeOrName" placeholder="请输入资产类别或部门名称" style="min-width: 300px"/>

      <Button style="margin-left: 10px" :loading="loading" color="primary" @click="doSearch1">查询</Button>

      <Button  :loading="loading" color="primary" @click="doSearch2">重置</Button>

    </div>
    <div class="h-panel-body">
      <Table :datas="datas" :border="true">
        <TableItem title="序号" :width="50">
          <template v-slot="{ index, data }">
            {{ data.assetsCode === '合计' ? '' : index + 1 }}
          </template>
        </TableItem>
        <TableItem title="资产编号" prop="assetsCode" :width="100"></TableItem>
        <TableItem title="资产类别" prop="assetsTypeName"></TableItem>
        <TableItem title="资产名称" prop="assetsName"  :width="200"></TableItem>
        <TableItem title="单位" prop="specification"></TableItem>
        <TableItem title="折旧起始日期" prop="checkDate"></TableItem>
        <TableItem title="单价" prop="price"></TableItem>
        <TableItem title="数量" prop="number" :width="50"></TableItem>
        <TableItem title="资产原值" prop="originalValue"></TableItem>
        <TableItem title="折旧次数" prop="expectUseMonth" :width="60"></TableItem>
        <TableItem title="单次折旧额" prop="currentMonthDepreciation"></TableItem>
        <TableItem title="上次折旧日期" prop="entryDate"></TableItem>
        <TableItem title="剩余次数" prop="remainingUseMonth" :width="60"></TableItem>
        <TableItem title="资产净值" prop="totalDepreciation"></TableItem>
        <TableItem title="部门" prop="deptName"></TableItem>
        <TableItem title="借方科目" prop="debitSubjectCode"></TableItem>
        <TableItem title="备注" prop="remark"></TableItem>
        <TableItem title="录入时间" prop="luruDate"></TableItem>
        <TableItem title="操作" align="center" >
          <div class="actions" slot-scope="{data}">
            <span v-if="data.assetsCode !== '合计'" @click="edit(data)">编辑</span>
            <span v-if="data.assetsCode !== '合计'" @click="remove(data)">删除</span>
            <span v-if="data.assetsCode !== '合计'" @click="disposal(data)">调出</span>
          </div>
        </TableItem>
      </Table>
      <div class="margin-top-bottom">
        <Pagination v-model="pageInfo" align="center" layout="pager" small/>
      </div>
    </div>
    <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
      <div slot="header" class="h-panel-bar">
        <span class="h-panel-title">固定资产信息</span>
      </div>
      <Form ref="form" v-width="800" mode="twocolumn" :labelWidth="150" :model="form" :rules="validationRules">
        <FormItem label="资产类别:" prop="assetsTypeId">
          <Select v-model="form.assetsTypeId" :datas="assetsType"  keyName="id" titleName="categoryName"
                  :filterable="true" :allow-create="true" placeholder="请输入或选择资产类别"></Select>
        </FormItem>
        <FormItem label="资产编码:" prop="assetsCode">
          <input type="text" v-model="form.assetsCode">
        </FormItem>
        <FormItem label="资产名称:" prop="assetsName">
          <input type="text" v-model="form.assetsName">
        </FormItem>

        <FormItem label="部门:" prop="deptId">
          <Select v-model="form.deptId" :datas="dept"  keyName="id" titleName="name"
                  :filterable="true" :allow-create="true" placeholder="请输入或选择部门名称"></Select>
        </FormItem>
        <FormItem label="开始折旧日期:" prop="checkDate">
          <DatePicker type="month" v-model="form.checkDate" :disabled="editInput"/>
        </FormItem>
<!--        <FormItem label="上次折旧日期:" prop="entryDate"  v-if="form.id">-->
<!--          <DatePicker type="month" v-model="form.entryDate" :disabled="true" />-->
<!--        </FormItem>-->
        <FormItem label="录入时间:" prop="luruDate" >
          <DatePicker type="date" v-model="form.luruDate"  />
        </FormItem>
        <FormItem label="单位:" prop="specification">
          <Select v-model="form.specification" :datas="unit"  keyName="id" titleName="name"
                  :filterable="true" :allow-create="true" placeholder="请输入或选择单位"></Select>
        </FormItem>
        <FormItem label="备注:" prop="remark">
          <input type="text" v-model="form.remark">
        </FormItem>

        <FormItem label="资产费用科目:" prop="debitSubject">
          <Select v-model="form.debitSubject" :datas="voucherSelect"    keyName="id" titleName="subjectFullName"
                  :filterable="true" :allow-create="true" placeholder="请输入或选择资产费用科目"></Select>
        </FormItem>
        <FormItem label="累计折旧科目:" prop="creditSubject">
          <Select v-model="form.creditSubject" :datas="voucherSelect"  keyName="id" titleName="subjectFullName"
                  :filterable="true" :allow-create="true" placeholder="请输入或选择累计折旧科目"></Select>
        </FormItem>
        <FormItem label="资产单价:" prop="price">
          <NumberInput v-model.number="form.price" :precision="2"  :min="0" :disabled="editInput"></NumberInput>
        </FormItem>
        <FormItem label="资产数量:" prop="number">
          <NumberInput v-model.number="form.number" :min="1" :useOperate="true" :useInt="true" :disabled="editInput"></NumberInput>
        </FormItem>
        <FormItem label="资产原值:" prop="originalValue">
          <NumberInput v-model.number="form.originalValue" :precision="2"  :min="0" :disabled="true"></NumberInput>
        </FormItem>

        <FormItem label="折旧总月:" prop="expectUseMonth">
          <NumberInput v-model.number="form.expectUseMonth" :min="0" :useOperate="true" :useInt="true" :disabled="editInput"></NumberInput>
        </FormItem>
        <FormItem label="已折月数:" prop="useMonth">
          <NumberInput v-model.number="form.useMonth" :min="0" :max="form.expectUseMonth" :useOperate="true" :useInt="true" :disabled="editInput"></NumberInput>
        </FormItem>
        <FormItem label="月折旧额:" prop="currentMonthDepreciation">
          <NumberInput v-model="form.currentMonthDepreciation" :precision="2"  :min="0" :disabled="true"></NumberInput>
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
        <Button @click="showForm=false">取消</Button>
      </div>
    </Modal>
    <Modal v-model="disposalForm" type="drawer-right" hasCloseIcon>
      <div slot="header" class="h-panel-bar">
        <span class="h-panel-title">资产调出</span>
      </div>
      <Form ref="form" v-width="800" mode="twocolumn" :labelWidth="150" :model="form" >
        <FormItem label="资产编码:" prop="assetsCode">
          <input type="text" v-model="form.assetsCode" :disabled="true">
        </FormItem>
        <FormItem label="资产名称:" prop="assetsName">
          <input type="text" v-model="form.assetsName" :disabled="true">
        </FormItem>
        <FormItem label="资产部门:" prop="deptName">
          <input type="text" v-model="form.deptName" :disabled="true">
        </FormItem>
        <FormItem label="资产原值:" prop="originalValue">
          <input type="text" v-model="form.originalValue" :disabled="true" >
        </FormItem>
        <FormItem label="资产数量:" prop="number">
          <input type="text" v-model="form.number" :disabled="true">
        </FormItem>
        <FormItem label="调出数量:" >
          <NumberInput v-model.number="form.disposalNumber" :min="1" :max="form.number" :useOperate="true" :useInt="true" :disabled="false"></NumberInput>
        </FormItem>
        <FormItem label="调出说明:" prop="disposal">
          <textarea v-autosize v-model="form.disposal" rows=4 placeholder="请输入"></textarea>
        </FormItem>

      </Form>
      <div class="text-center">
        <Button color="green" @click="disposalSubmit1" :loading="loading">调出</Button>
        <Button @click="disposalForm=false">取消</Button>
      </div>
    </Modal>
  </app-content>

</template>


<script>

import moment from "moment/moment";
import * as XLSX from 'xlsx';
import {mapState} from "vuex";
const emptyForm = {
    // 资产记录的唯一标识，初始值为 null，表示新增状态
  // "id": null,
  // 资产编码，初始为空字符串
  "assetsCode": "",
  // 资产名称，初始为空字符串
  "assetsName": "",
  // 资产规格型号，初始为空字符串
  "specification": "",
  // 资产类别 ID，初始值为 null
  "assetsTypeId": null,
  // 资产所属部门 ID，初始值为 null
  "deptId": null,
  // 上次折旧日期，初始为空字符串
  "entryDate": "",
  // 资产开始折旧日期，初始为空字符串
  "checkDate": "",
  // 资产费用科目，初始为空字符串
  "debitSubject": null,
  // 累计折旧科目，初始为空字符串
  "creditSubject": null,
  // 资产原值，初始为空字符串
  "originalValue": 0,
  // 预计折旧总月数，初始为空字符串
  "expectUseMonth": 0,
  // 已折旧月数，初始值为 "0"
  "useMonth": 0,
  // 剩余折旧月数，初始值为 "0"
  "remainingUseMonth": 0,
  // 每月折旧额，初始值为 "0"
  "currentMonthDepreciation": 0,
  // 资产净值，初始值为 "0"
  "totalDepreciation": 0,
  // 资产备注信息，初始为空字符串
  "remark": "",
  // 资产单价
  "price": 0,
  // 资产数量
  "number": 1,
  //处置日期
  "disposalDate": "",
  //处置说明
  "disposal": "",
  //处置数量
  "disposalNumber": 1,
  //录入时间
  "luruDate": moment(new Date()).format("YYYY-MM-DD"),
};
/**
 * 固定资产
 */
export default {
  name: 'FixedAssets',
  data() {
    return {
      moment,
            // 存储表格展示的数据，初始为空数组
      datas: [],
      // 存储科目相关的数据，初始为空数组
      subjects: [],
      // 存储资产类别的数据，初始为空数组
      assetsType: [],
      // 存储凭证选择的数据，初始为空数组
      voucherSelect: [],
      // 存储部门相关的数据，初始为空数组
      dept: [],
      //单位
      unit: [
        { id: '台', name: '台' },
        { id: '张', name: '张' },
        { id: '套', name: '套' },
        { id: '个', name: '个' },
        { id: '组', name: '组' },
        { id: '件', name: '件' },
        { id: '辆', name: '辆' },
        { id: '把', name: '把' }
      ],
      // 复制空表单对象，避免直接修改原始的 emptyForm 对象，保证每次重置表单时数据一致
      form: Object.assign({}, emptyForm),
      // 表单验证规则，定义需要进行必填项验证的字段，当前仅对 companyName 字段进行必填验证
      validationRules: {
        required: ["assetsCode", "assetsName", "assetsTypeId", "deptId", "checkDate", "luruDate","debitSubject", "creditSubject",
           "expectUseMonth","price","number"
          ]
      },
      // 存储需要删除的资产数据对象
      rmData: {},

      // 控制添加/编辑资产表单模态框的显示与隐藏，false 表示隐藏
      showForm: false,
      //处置表单
      disposalForm:false,

      // 控制日期选择器是否禁用的状态，false 表示不禁用
      used: false,
      // 控制提交按钮加载状态的布尔值，true 表示正在加载
      loading: false,
      // 初始化 accountDate 属性
      accountDate: null,
      // 分页信息对象，包含当前页码和数据总条数
      pageInfo: {
        // 当前页码，初始为第 1 页
        page: 1,
        // 数据总条数，初始为 0
        total: 0
      },
      //账套对应的辅助表部门id
      deptId: null,
      // 搜索关键词，用于在表格中进行数据筛选
      keyword: '',
      //可编辑状态
      editInput: false,
      //折旧记录
      disposalDetails:[],
      //资产类别或部门名称
      assetsCodeOrName: '',
    };
  },
  computed: {
    ...mapState(['currentAccountSets']),
  },
  watch: {
    /**
     * 监听 showForm 属性的变化
     * 当 showForm 的值变为 false 时，意味着新增/编辑表单弹窗关闭，
     * 此时调用 reset 方法重置表单数据。
     * @param {boolean} val - showForm 的新值
     */
    showForm(val) {
      if (!val) {
        // 当弹窗关闭时，重置表单数据
        this.reset();
      }
    },
    disposalForm(val) {
      if (!val) {
        // 当弹窗关闭时，重置表单数据
        this.reset();
      }
    },
    /**
     * 监听 pageInfo 对象的变化
     * 使用 deep 选项深度监听 pageInfo 对象的所有属性变化，
     * 当 pageInfo 发生变化时，调用 loadList 方法重新加载数据列表。
     */
    pageInfo: {
      deep: true, // 深度监听 pageInfo 对象的所有属性变化
      /**
       * 当 pageInfo 对象发生变化时的处理函数
       * 调用 loadList 方法重新加载数据列表
       */
      handler() {
        // 重新加载数据列表
        this.loadList();
      }
    },

    // 同时监听其他可能影响计算的字段
    // 监听 资产原值  属性的变化
    'form.originalValue': {
      handler: function(newVal) {
        // 若不在编辑状态，触发计算
        this.calculateDepreciation();
      },
      immediate: true // 立即执行一次监听函数
    },
    // 监听 预计折旧总月数  属性的变化
    'form.expectUseMonth': {
      handler: function(newVal) {
        if (newVal === 0) {
          this.form.currentMonthDepreciation = "0";
        }
        // 若不在编辑状态，触发计算
        this.calculateDepreciation();
      },
      immediate: true // 立即执行一次监听函数
    },
    // 监听 已折旧月数  属性的变化
    'form.useMonth': {
      handler: function(newVal) {
        if (newVal === 0) {
          // this.form.currentMonthDepreciation = "0";
        }
        // 若不在编辑状态，触发计算
        this.calculateDepreciation();
      },
      // immediate: true // 立即执行一次监听函数
    },

    // 监听 资产数量  属性的变化
    'form.number': {
      handler: function(newVal) {
        // 若不在编辑状态，触发计算
        this.calculateOriginalValue();
      },
      immediate: true // 立即执行一次监听函数
    },
    // 监听 资产单价  属性的变化
    'form.price': {
      handler: function(newVal) {
        // 若不在编辑状态，触发计算
        this.calculateOriginalValue();
      },
      immediate: true // 立即执行一次监听函数
    },
    /**
     * 监听资产类别ID的变化，自动生成资产编号
     */
    'form.assetsTypeId': {
      handler: async function(newVal) {
        if (newVal && !this.editInput) {
          // 只有在新增模式下才自动生成编号
          this.form.assetsCode = await this.generateNextAssetsCode();
        }
      }
    },
  },
  methods: {

    /**
     * 导出Excel
     */
    exportExcel() {
      try {
        // 导出所有数据，包括合计行
        const exportData = this.datas;

        if (exportData.length === 0) {
          this.$Message.warning('没有可导出的数据');
          return;
        }

        // 准备导出数据，保持与表格显示一致的顺序
        const data = exportData.map((item, index) => {
          // 对于合计行，序号显示为空
          const rowIndex = item.assetsCode === '合计' ? '' : index + 1;

          return {
            '序号': rowIndex,
            '资产编号': item.assetsCode || '',
            '资产类别': item.assetsTypeName || '',
            '资产名称': item.assetsName || '',
            '单位': item.specification || '',
            '折旧起始日期': item.checkDate || '',
            '单价': item.price || 0,
            '数量': item.number || 0,
            '资产原值': item.originalValue || 0,
            '折旧次数': item.expectUseMonth || 0,
            '单次折旧额': item.currentMonthDepreciation || 0,
            '上次折旧日期': item.entryDate || '',
            '剩余次数': item.remainingUseMonth || 0,
            '资产净值': item.totalDepreciation || 0,
            '部门': item.deptName || '',
            '借方科目': item.debitSubjectCode || '',
            '备注': item.remark || '',
            '录入时间': item.luruDate || ''
          };
        });
        // 创建工作表
        const ws = XLSX.utils.json_to_sheet(data, { skipHeader: false });

        // 获取账套名称，生成文件名
        const accountSetName = this.currentAccountSets.companyName || '未知账套';
        const fileName = `${accountSetName}-固定资产列表.xlsx`;
        const sheetName = `${accountSetName}-固定资产列表`;
        // 创建工作簿
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, sheetName);

        // 导出文件
        XLSX.writeFile(wb, fileName);

        // 简单延时后显示成功提示，改善用户体验
        setTimeout(() => {
          this.$Message.success('数据导出成功，请查看浏览器下载列表');
        }, 100);
      } catch (error) {
        console.error('导出失败:', error);
        this.$Message.error('导出失败');
      }
    },
    /**
     * 资产数量改变时，计算资产原值
     */
    calculateOriginalValue() {
      // 具体计算逻辑
      const { price, number } = this.form;
      // 资产原值
      this.form.originalValue = price * number;
    },


    /**
     * 根据资产原值进行计算
     */
    calculateDepreciation() {
      // 具体计算逻辑
      const { originalValue, expectUseMonth,useMonth } = this.form;
      // 单次折旧额
      const currentMonthDepreciation = originalValue / expectUseMonth;
      // 剩余折旧月数
      const remainingUseMonth = expectUseMonth - useMonth;
      // 已折旧月数不能大于预计折旧总月数
      if (remainingUseMonth < 0){
        this.form.useMonth = expectUseMonth;
      }
      // console.log("总折旧月数"+this.form.expectUseMonth);
      // console.log("剩余折旧月数"+this.form.useMonth);
      // 计算资产净值
      if (originalValue && expectUseMonth) {
        if  (expectUseMonth > 0 ) {

          //单次折旧额
          this.form.currentMonthDepreciation = currentMonthDepreciation.toFixed(2);
          // 资产净值
          this.form.totalDepreciation = originalValue-currentMonthDepreciation*useMonth;
          // 剩余折旧月数
          this.form.remainingUseMonth = remainingUseMonth;
        }
        else {
          this.form.currentMonthDepreciation = "0";
        }
      }

    },
    /**
     * 新增表单数据
     */
    async add() {
      this.showForm = true;
      this.editInput = false;
      // 自动生成资产编号
      this.form.assetsCode = await this.generateNextAssetsCode();

    },

    async add1() {
      // 确保数据已加载
      // console.log(this.datas.length)

      this.showForm = true;
      this.editInput = false;

      // 先重置表单
      this.form = Object.assign({}, emptyForm);

      // 自动生成资产编号
      this.form.assetsCode = await this.generateNextAssetsCode();

      // 获取真正的最后一条资产数据（排除合计行）
      const realData = this.datas.filter(item => item.assetsCode !== '合计');
      // 若有历史数据，填充最后一条数据的内容
      if (realData.length > 0) {
        // console.log('开始显示数据:');
        const lastData = realData[realData.length - 1];
        // console.log("lastData JSON格式:", JSON.stringify(lastData, null, 2));
        // 复制上条数据的关键字段
        this.form = {
          ...emptyForm, // 先重置为空表单
          // assetsTypeId: lastData.assetsTypeId, // 资产类别ID
          deptId: lastData.deptId, // 部门ID
          specification: lastData.specification, // 单位
          debitSubject: lastData.debitSubject, // 借方科目
          creditSubject: lastData.creditSubject, // 贷方科目
          // expectUseMonth: lastData.expectUseMonth, // 预计折旧总月数
          // price: lastData.price, // 单价
          number: 1, // 数量重置为 1
          // originalValue: lastData.originalValue, // 资产原值
          // currentMonthDepreciation: lastData.currentMonthDepreciation, // 单次折旧额
          // remainingUseMonth: lastData.remainingUseMonth, // 剩余折旧月数
          // totalDepreciation: lastData.totalDepreciation, // 资产净值
          // remark: lastData.remark, // 备注
          assetsCode: this.form.assetsCode // 保持新生成的资产编号
        };

        // console.log('新表单数据:', this.form);

      }
    },

    /**
     * 生成下一个资产编号
     */
    async generateNextAssetsCode() {
      if (!this.form.assetsTypeId) {
        return '';
      }
      try {
        // 根据资产类别ID获取该类别的资产列表，以确定下一个编号
        const assetsTypeItem = this.assetsType.find(type => type.id === this.form.assetsTypeId);
        if (!assetsTypeItem) {
          return '';
        }

        // 获取该资产类别下的所有资产
        const response = await this.$api.assets.assets.list();
        const allAssets = response.data || [];

        // 筛选出相同资产类别的资产
        const sameTypeAssets = allAssets.filter(asset =>
            asset.assetsTypeId === this.form.assetsTypeId && asset.id !== this.form.id
        );

        // 获取该资产类别的编码前缀
        const typeCode = assetsTypeItem.categoryCode || '';

        if (!typeCode) {
          return '';
        }
        // 找出该类别下最大的序号
        let maxSequence = 0;
        sameTypeAssets.forEach(asset => {
          if (asset.assetsCode && asset.assetsCode.startsWith(typeCode)) {
            const sequenceStr = asset.assetsCode.substring(typeCode.length);
            const sequence = parseInt(sequenceStr, 10);
            if (!isNaN(sequence) && sequence > maxSequence) {
              maxSequence = sequence;
            }
          }
        });
        // 生成新的序号（三位数，不足补零）
        const nextSequence = maxSequence + 1;
        const sequenceStr = nextSequence.toString().padStart(3, '0');

        return typeCode + sequenceStr;
      } catch (error) {
        console.error('生成资产编号失败:', error);
        return '';
      }
    },

    disposalSubmit1() {
      if (this.form.disposalNumber <=0 || this.form.disposalNumber > this.form.number) {
        this.$Message.error('调出数量不能为0或者大于该资产数量');
        return;
      }
      // 处置时间
      this.form.disposalDate = moment().format("YYYY-MM-DD");
      //保存处置数据
      this.disposalDetails = this.form;
      this.$api.assets.disposal.save(this.disposalDetails).then(() => {
        // 修改资产数据-减处置数量
        this.form.number = this.form.number - this.form.disposalNumber;
        if (this.form.number > 0) {
          this.handleUpdateAsset();
        }else  {
          this.handleDeleteAsset();
        }
      }).catch((error) => {
        console.error('处置资产失败:', error);
        this.$Message.error('处置资产失败');
      }).finally(() => {
        this.loading = false;
      });


    },
    // 更新资产信息逻辑
    handleUpdateAsset() {
      // 修改资产数据-资产原值
      this.form.originalValue = this.form.originalValue - this.form.disposalNumber * this.form.price;

      // 修改资产数据单次折旧额（注意顺序）
      if (this.form.expectUseMonth > 0) {
        this.form.currentMonthDepreciation = (this.form.originalValue / this.form.expectUseMonth).toFixed(2);
      }
      // 修改资产数据-资产净值
      if (this.form.remainingUseMonth > 0) {
        this.form.totalDepreciation = this.form.currentMonthDepreciation * this.form.remainingUseMonth;
      }
      //修改调出资产默认值
      this.form.disposalNumber = 1;
      const apiMethod = this.form.id ? 'update' : 'save';
      this.$api.assets.assets[apiMethod](this.form)
          .then(() => {
            this.loadList();
            this.disposalForm = false;
          })
          .catch((error) => {
            console.error('更新资产失败:', error);
            this.$Message.error('更新资产失败');
          })
          .finally(() => {
            this.loading = false;
          });
    },
    // 删除资产逻辑
    handleDeleteAsset() {
      this.$api.assets.assets.delete(this.form.id)
          .then(() => {
            this.loadList();
            this.disposalForm = false;
          })
          .catch((error) => {
            console.error('删除资产失败:', error);
            this.$Message.error('删除资产失败');
          })
          .finally(() => {
            this.loading = false;
          });
    },
    // 处置新增
    disposalSubmit() {
      this.$Message("亲，调出功能正在修改，暂未开放！");
    },
    submit() {
      // 调用表单组件的 valid 方法进行表单验证，并获取验证结果
      let validResult = this.$refs.form.valid();

      // 判断验证结果是否通过
      if (validResult.result) {
        // 资产编号唯一性验证
        const isDuplicate = this.datas.some(item =>
            item.assetsCode === this.form.assetsCode &&
            item.id !== this.form.id // 排除当前编辑的记录
        );

        if(isDuplicate){
          this.$Notice.error({
            title: "验证失败",
            content: `资产编号：${this.form.assetsCode},已存在，不能重复出入！`
          });
        }else {
          if(this.form.currentMonthDepreciation >=0){
            // 验证通过，设置提交按钮为加载状态
            this.loading = true;
            // 使用 moment 库将账套启用日期格式化为 'YYYY-MM-DD' 格式
            this.form.enableDate = moment(this.form.enableDate).format("YYYY-MM-DD");
            this.form.checkDate = moment(this.form.checkDate).format("YYYY-MM-DD");
            // 根据表单是否有 id 决定调用更新或保存接口
            this.$api.assets.assets[this.form.id ? 'update' : 'save'](this.form).then(() => {
              // 操作成功，刷新资产列表
              this.loadList();
              // 关闭表单弹窗
              this.showForm = false;
              // 关闭加载状态
              this.loading = false;
            }).catch(() => {
              // 操作失败，关闭加载状态
              this.loading = false;
            })
          } else {
            this.noticeTitle("error");
          }
        }
      }
    },
    noticeTitle(type) {
      let text = { info: '消息', success: '成功', warn: '警告', error: '错误' }[type];
      this.$Notice({
        type,
        title: text,
        content: `请将必填值填写完整,且月折旧额大于0。`
      });
    },
    /**
     * 加载所有凭证选择数据
     * 优先从 localStorage 中获取缓存的凭证选择数据，若存在则先使用缓存数据，
     * 同时发起 API 请求获取最新的凭证选择数据并更新 localStorage 中的缓存
     */
    loadVoucherSelect() {
      // 调用 API 发起请求，获取所有的凭证选择数据
      // this.$api.setting.subject.voucherSelect().then(({data}) => {
      //   // 将 API 返回的凭证选择数据赋值给组件的 voucherSelect 属性
      //   this.voucherSelect = data;
      //   // 将凭证选择数据以 JSON 字符串形式存储到 localStorage 中
      //   // localStorage.setItem("voucherSelect", JSON.stringify(data));
      // });

      // 调用 API 发起请求，获取所有的凭证选择数据
      return this.$api.setting.subject.voucherSelect().then(({data}) => {
        // 将 API 返回的凭证选择数据赋值给组件的 voucherSelect 属性
        this.voucherSelect = data;
        // 将凭证选择数据以 JSON 字符串形式存储到 localStorage 中
        // localStorage.setItem("voucherSelect", JSON.stringify(data));
      });

    },
    /**
     * 加载所有资产类别数据
     * @returns {Promise<void>}
     */
    async loadAssetsType() {
      try {
        // 等待 API 请求完成
        const response = await this.$api.assets.assetsType.list();
        // 将响应数据中的 data 字段赋值给组件的 datas 属性
        this.assetsType = response.data || [];
      } catch (error) {
        // 打印请求失败的错误信息
        console.error('获取资产类别列表失败:', error);
      }
    },

    /**
     * 加载辅助核算类别详情列表数据
     * 该方法会调用 API 获取指定辅助核算类别下的详情列表数据，
     * 并更新组件的表格数据和分页信息。
     */
    loadDept() {
      return new Promise((resolve, reject) => {
        // 调用 API 获取辅助核算类别列表
        this.$api.setting.accountingCategory.list().then(({data}) => {
          const departmentItem = data.find(val => val.name === '部门');
          if (departmentItem) {
            this.deptId = departmentItem.id;
            this.$api.setting.accountingCategoryDetails.list(this.deptId,{page: this.pageInfo.page, keyword: this.keyword}).then(({data}) => {
              this.dept = data.records || [];
              resolve();
            }).catch(reject);
          } else {
            // 处理未找到 "部门" 的情况，可根据需求修改
            console.warn('未找到"部门" 的数据');
            this.deptId = null;
            resolve();
          }
        }).catch(reject);
      });
    },
    /**
     * 重置表单数据
     * 将表单数据对象 form 重置为初始状态，即复制 emptyForm 对象
     */
    reset() {
      this.form = Object.assign({}, emptyForm);
    },
    /**
     * 加载资产列表数据
     *
     * 该函数用于获取资产列表，并对列表中的每项数据进行处理：
     * 1. 根据资产类型ID匹配资产类型名称
     * 2. 根据部门ID匹配部门名称
     * 3. 根据借方科目ID匹配资产费用科目名称
     * 4. 根据贷方科目ID匹配累计折旧科目名称
     *
     * 处理后的数据将存储在 this.datas 中
     *
     * @returns {Promise<void>} 无返回值
     */
    async loadList1() {
      try {
        const { data } = await this.$api.assets.assets.list();
        if (data.length > 0) {
          data.forEach(item => {
            const assetsTypeItem = this.assetsType.find(type => type.id === item.assetsTypeId);
            // 若找到对应的资产类型，将其名称添加到 item 中
            item.assetsTypeName = assetsTypeItem ? assetsTypeItem.categoryName : '';
            // 查找对应的部门信息
            const deptItem = this.dept.find(dept => dept.id === item.deptId);
            // 若找到对应的部门，将其名称添加到 item 中
            item.deptName = deptItem ? deptItem.name : '';
            // 查找资产费用科目信息
            const debitSubjectItem = this.voucherSelect.find(voucher => voucher.id === item.debitSubject);
            // 若找到对应的资产费用科目，将其名称添加到 item 中
            item.debitSubjectName = debitSubjectItem ? debitSubjectItem.subjectFullName : '';

            // 查找累计折旧科目信息
            const creditSubjectItem = this.voucherSelect.find(voucher => voucher.id === item.creditSubject);
            // 若找到对应的累计折旧科目，将其名称添加到 item 中
            item.creditSubjectName = creditSubjectItem ? creditSubjectItem.subjectFullName : '';
          });
        }
        this.datas = data || [];
      } catch (error) {
        console.error('获取资产列表失败:', error);
      }
    },
    async loadList() {
      try {
        const { data } = await this.$api.assets.assets.list();
        // console.log("datas JSON格式:", JSON.stringify(data, null, 2));
        // 构建快速查找的 Map
        const assetsTypeMap = new Map(this.assetsType.map(type => [type.id, type.categoryName]));
        const deptMap = new Map(this.dept.map(dept => [dept.id, dept.name]));
        const voucherMap = new Map(this.voucherSelect.map(voucher => [voucher.id, voucher.subjectFullName]));
        const voucherCodeMap = new Map(this.voucherSelect.map(voucher => [voucher.id, voucher.code]));
        if (data.length > 0) {
          data.forEach(item => {
            item.assetsTypeName = assetsTypeMap.get(item.assetsTypeId) || '';
            item.deptName = deptMap.get(item.deptId) || '';
            item.debitSubjectName = voucherMap.get(item.debitSubject) || '';
            item.debitSubjectCode = voucherCodeMap.get(item.debitSubject) || '';
            item.creditSubjectName = voucherMap.get(item.creditSubject) || '';
            // 确保 createTime 字段存在且格式正确
            if (item.createTime) {
              item.createTime = moment(item.createTime).format('YYYY-MM-DD HH:mm:ss');
            }
          });
        }

        // 计算合计行数据
        const totals = data.reduce((acc, item) => {
          acc.number += Number(item.number) || 0;
          acc.originalValue += Number(item.originalValue) || 0;
          acc.currentMonthDepreciation += Number(item.currentMonthDepreciation) || 0;
          acc.totalDepreciation += Number(item.totalDepreciation) || 0;
          return acc;
        }, {
          number: 0,
          originalValue: 0,
          currentMonthDepreciation: 0,
          totalDepreciation: 0
        });

        // 添加合计行
        const summaryRow = {
          assetsCode: '合计',
          number: totals.number,
          originalValue: parseFloat(totals.originalValue.toFixed(2)),
          currentMonthDepreciation: parseFloat(totals.currentMonthDepreciation.toFixed(2)),
          totalDepreciation: parseFloat(totals.totalDepreciation.toFixed(2)),
          // 其他非合计字段设为空字符串
          assetsTypeName: '',
          assetsName: '',
          specification: '',
          checkDate: '',
          price: '',
          expectUseMonth: '',
          entryDate: '',
          remainingUseMonth: '',
          deptName: '',
          remark: ''
        };

        this.datas = [...data, summaryRow];
      } catch (error) {
        console.error('获取资产列表失败:', error);
        // 可选：添加用户提示，如 this.$message.error('获取资产列表失败');
      }

    },

    remove(data) {
      this.$Confirm("确认删除?").then(() => {
        if (data.entryDate) {
          this.$Message("亲，该资产已经折旧过了，不能删除！");
          return;
        }
        this.$api.assets.assets.delete(data.id).then(() => {
          this.loadList();
        })
      })
    },
    edit(data){
      // 开始编辑，设置标志位为 true
      this.form = Object.assign({}, data);
      this.showForm = true;
      // 根据资产的上次折旧日期是否存在，设置输入框的可编辑状态
      // 若存在上次折旧日期，将 editInput 设置为 true，禁用相关输入框
      // 若不存在，设置为 false，允许编辑相关输入框
      this.editInput = !!data.entryDate;
    },
    //测试批量更新
    disposal(data){
      this.form = Object.assign({}, data);
      this.disposalForm = true;

    },
    //查询资产列表
    doSearch1(){
      if(this.assetsCodeOrName){
        // this.datas
        // 调用模糊查询方法过滤数据
        this.filterDataByKeyword(this.assetsCodeOrName);
      }
    },

    /**
     * 根据关键字模糊查询数据列表
     * 支持按资产类别和部门进行过滤
     * @param {String} keyword - 查询关键字，支持模糊匹配
     */
    filterDataByKeyword(keyword) {
      // 将查询关键字转换为小写并去除首尾空格
      const searchKey = String(keyword).toLowerCase().trim();

      // 对数据列表进行过滤
      const filteredData = this.datas.filter(item => {
        // 跳过合计行
        if (item.assetsCode === '合计') {
          return false;
        }

        // 获取资产类别名称，转换为字符串并转为小写
        const assetsType = String(item.assetsTypeName || '').toLowerCase();

        // 获取部门名称，转换为字符串并转为小写
        const deptName = String(item.deptName || '').toLowerCase();

        // 只要资产类别或部门包含查询关键字就保留该条记录
        return assetsType.includes(searchKey) || deptName.includes(searchKey);
      });

      // 计算各项金额的合计值
      const totalItem = {
        assetsCode: '合计',
        assetsTypeName: '',
        assetsName: '',
        specification: '',
        price: filteredData.reduce((sum, item) => sum + (item.price || 0), 0),
        number: filteredData.reduce((sum, item) => sum + (item.number || 0), 0),
        originalValue: filteredData.reduce((sum, item) => sum + (item.originalValue || 0), 0),
        expectUseMonth: 0,
        currentMonthDepreciation: parseFloat(filteredData.reduce((sum, item) => sum + (item.currentMonthDepreciation || 0), 0)).toFixed(2),
        entryDate: '',
        remainingUseMonth: 0,
        totalDepreciation: filteredData.reduce((sum, item) => sum + (item.totalDepreciation || 0), 0),
        deptName: '',
        remark: ''
      };
      // 将过滤后的数据和合计对象一起返回
      this.datas = [...filteredData, totalItem];
    },
    //重置查询
    doSearch2(){
      this.assetsCodeOrName= '';
      this.loadList();
    },
  },
  mounted() {
    // this.loadVoucherSelect();
    // this.loadAssetsType();
    //
    // // 等待 loadDept 方法执行完成
    // this.loadDept().then(() => {
    //   this.loadList();
    //
    // });

    // 使用 Promise.all 确保所有依赖数据都加载完成后再加载资产列表
    Promise.all([
      this.loadVoucherSelect(),
      this.loadAssetsType(),
      this.loadDept()
    ]).then(() => {
      this.loadList();
    }).catch(error => {
      console.error('初始化数据加载失败:', error);
      this.$Message.error('数据加载失败，请刷新页面重试');
    });

  },
};
</script>
<style scoped lang="less">
.h-panel-bar {
  display: flex; /* 使用 Flexbox 布局 */
  justify-content: space-between; /* 让子元素两端对齐 */
  align-items: center; /* 垂直居中对齐 */
}
</style>
